import PropTypes from 'prop-types';

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';

import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

const MaterialDivider = ({ 
  index, title, showDeleteIcon, showChip, handleDelete, deleteIndex, deleteId 
}) => {
  return(
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', ml: 1 }}>
      <Typography
        component="h5"
        variant="h5"
        sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}
        color={'text.secondary'}
      >
        {title} {index + 1}
      </Typography>

      <Divider
        sx={{
          flexGrow: 1,
          ml: 3,
          mr: (showDeleteIcon ? 2 : (showChip ? 2 : 0)),
          borderColor: 'grey.900',
        }}
      />

      {
        showChip &&
        <Chip label="In use" color="success" sx={{ mr: 1 }} />
      }

      {
        showDeleteIcon &&
        <RemoveCircleOutlineIcon 
          color="error" 
          fontSize="large" 
          sx={{mr: 1, cursor: 'pointer'}}
          onClick={e => handleDelete(deleteIndex, deleteId)}
        />
      }
    </Box>
  );
};

MaterialDivider.propTypes = {
  index: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  showDeleteIcon: PropTypes.bool.isRequired,
  showChip: PropTypes.bool.isRequired,
  handleDelete: PropTypes.func.isRequired,
  deleteIndex: PropTypes.number.isRequired,
  deleteId: PropTypes.string.isRequired,
};

export default MaterialDivider;